import React from 'react';

import Pill from '@components/Pill';
import { search_page_path, topic_landing_path } from '@routes';
import { encodeEntity } from '@utils/formatting';

// TODO: Replace with real top searches from Algolia
// {@link https://app.asana.com/1/1200145886478/project/1201413338509198/task/1209940023501323?focus=true}
const SEARCH_EXAMPLES = ['Amazon', 'Startups', 'Venture Capital', 'Sam Altman', 'Apple'];

const SearchPills = ({ isSearchLandingPage, topRelatedEntities }) => {
  const pillTextList = isSearchLandingPage
    ? SEARCH_EXAMPLES.map((query) => ({ text: query, href: search_page_path({ query }) }))
    : topRelatedEntities.map(({ name }) => ({
        text: name,
        href: topic_landing_path(encodeEntity(name)),
      }));

  return (
    <ul className="m-0 mt-12 list-none p-0">
      {pillTextList.map(({ text, href }) => (
        <Pill key={text} className="!font-suisse-intl" href={href} text={text} />
      ))}
    </ul>
  );
};

export default SearchPills;
